import { useReducer } from 'react';
import { ConstantValues } from '../../utils/extensions/constantEx'

const NurseServiceBookingFormInitalState = {
    selectedBookingJosn: { id: 0, patientName: '', patientPhone: '', nurseId: 0 },
    bookingFormValue: {
            id: 0,
            nurseId: 0,
            nurseName:  '',
            bookingDate: null,
            selectedServiceType: null,
            serviceDutyDays: 0,
            bookedDate: null,
            patientName: '',
            patientPhone: '',
            patientPlace: '',
            notes: ''
        },//{ id: 0, patientName: '', patientPhone: '', nurseId: 0 },
    patientAddress: {
        id: ConstantValues.DefaultContactAddressId,
        addressText: '',
        district: '',
        pincode: ''
    }
};

export const NurseServiceBookingFormReducer = (state = NurseServiceBookingFormInitalState, action) => {
    switch (action.type) {
        case 'SET_SELECTED_BOOKING_JSON':
            return {
                ...state,
                selectedBookingJosn: { ...action.payload.selectedBooking }
            };
        case 'SET_SERVICE_BOOKING_FORM_VALUE':
            return {
                ...state,
                bookingFormValue: { ...action.payload.bookingFormValue }
            };
        case 'SET_SERVICE_BOOKING_PATIENT_ADDRESS':
            return {
                ...state,
                patientAddress: { ...action.payload.patientAddress }
            };
        default:
            return state;
    }
};

export const useNurseServiceBookingForm = () => {
    const [bookingFormState, dispatchBookingFormState] = useReducer(NurseServiceBookingFormReducer, NurseServiceBookingFormInitalState);

    const SetSelectedBookingJson = (selectedBooking) => {
        dispatchBookingFormState({
            type: "SET_SELECTED_BOOKING_JSON",
            payload: {
                selectedBooking: selectedBooking
            }
        })
    }

    const SetBookingFormValue = (fromValue) => {
        dispatchBookingFormState({
            type: "SET_SERVICE_BOOKING_FORM_VALUE",
            payload: {
                bookingFormValue: fromValue
            }
        })
    }

    const SetBookingContactAddress = (contactAddress) => {
        dispatchBookingFormState({
            type: "SET_SERVICE_BOOKING_PATIENT_ADDRESS",
            payload: {
                patientAddress: contactAddress
            }
        })
    }

    return {
        ...bookingFormState,
        SetSelectedBookingJson,
        SetBookingFormValue,
        SetBookingContactAddress
    }
}

